import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=7c1503e0&scoped=true"
import script from "./settings.vue?vue&type=script&lang=ts"
export * from "./settings.vue?vue&type=script&lang=ts"
import style0 from "./settings.vue?vue&type=style&index=0&id=7c1503e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1503e0",
  null
  
)

export default component.exports